import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-app-project',
  templateUrl: './app-project.component.html',
  styleUrls: ['./app-project.component.scss']
})
export class AppProjectComponent implements OnInit {
  isCollapsed = true;
  listTab: boolean = true;
  gridTab: boolean;
  constructor() { }

  ngOnInit(): void {
  }

  onMenuTab(number) {
    this.listTab = false;
    this.gridTab = false;

    if (number == '1') {
      this.listTab = true;
    }
    else if (number == '2') {
      this.gridTab = true;
    }
  }

}
